// services/featureFlagService.ts

/**
 * Simplified FeatureFlagService that returns true for all feature flags.
 * Azure App Configuration integration is disabled.
 */
class FeatureFlagService {
  private isInitialized = false;

  constructor() {
    // No Azure connection - all flags return true
  }

  // Initialize - immediately set as initialized
  async initialize(): Promise<void> {
    if (this.isInitialized) return;

    console.log('Feature flags initialized (all flags enabled)');
    this.isInitialized = true;
  }

  // Get feature flag - always returns true
  getFeatureFlag(flagName: string): boolean {
    return true;
  }

  // Get all flags - returns empty object since all flags are implicitly enabled
  getAllFlags(): Record<string, boolean> {
    return {};
  }

  // Manual refresh - no-op since no remote connection
  async refresh(): Promise<void> {
    // No-op
  }

  // Check if service is ready
  isReady(): boolean {
    return this.isInitialized;
  }

  // Cleanup - no-op since no intervals or connections
  destroy(): void {
    // No-op
  }
}

export default new FeatureFlagService();